import styles from './Card.module.css'
import { AiFillGithub } from 'react-icons/ai'

const Cards = ({ image, title, demo, description, technologies }) => {
    return (
        <li>
            <div className={styles.card}>
                <img src={image} alt={title} loading="lazy" />
                <div className={styles['card-overlay']}>
                    <div className={styles['card-header']}>
                        <div className={styles['card-content']}>
                            <h3 className={styles['card-title']}>{title}</h3>
                        </div>
                    </div>
                    <p className={styles['card-description']}>
                        {description}
                    </p>
                    <div className={styles['card-links']}>
                        <div className={styles.technologies}>
                            {
                                technologies.map((technology) => {
                                    return (
                                        <img src={technology} alt={technology.split('/').pop().split('.')[0]} key={technology} loading="lazy" />
                                    )
                                })
                            }
                        </div>
                        <a href={demo} target='_blank' rel='noreferrer' className={styles['git-link']}>
                            <AiFillGithub size={38} href={demo} target='_blank' rel='noreferrer' />
                        </a>
                    </div>
                </div>
            </div>
        </li>
    )
}

export default Cards
